import {
  MonitorIoTClass,
  MonitorType,
} from "@/services/backend/qpm/types/enums";
import { MonitorServiceDefaultsList } from "@/services/backend/qpm/monitors/types/monitor";

export const DEFAULT_MONITOR_INSTALL_NS = 5 * 60 * 1_000_000_000;
export const DEFAULT_MONITOR_MAINTAIN_NS = 150 * 1_000_000_000;

type MonitorDefaultTimes = {
  install: number;
  maintain: number;
};

export function resolveMonitorDefaultTimes(
  defaults: MonitorServiceDefaultsList | undefined,
  monitorType: MonitorType,
  iotClass?: MonitorIoTClass,
  checkpointVisual = false,
): MonitorDefaultTimes {
  const items = defaults?.items ?? [];
  const sameType = items.filter(
    (item) =>
      item.monitorType === monitorType &&
      (monitorType !== MonitorType.Checkpoint ||
        item.checkpointVisual === checkpointVisual),
  );

  const iotMatch =
    iotClass !== undefined
      ? sameType.find((item) => item.iotClass === iotClass)
      : undefined;
  const typeFallback = sameType.find((item) => item.iotClass === undefined);
  const selected = iotMatch ?? typeFallback ?? sameType[0];

  const install = selected?.installationTime ?? DEFAULT_MONITOR_INSTALL_NS;
  const maintain = selected?.maintenanceTime ?? DEFAULT_MONITOR_MAINTAIN_NS;

  return {
    install: install > 0 ? install : DEFAULT_MONITOR_INSTALL_NS,
    maintain: maintain > 0 ? maintain : DEFAULT_MONITOR_MAINTAIN_NS,
  };
}
